import styled from "styled-components";

import { motion } from "@enkor/framer-motion";

import { grayScale, pink } from "@enkor/design/colors";

import { BUTTON_BOX } from "../EventDetailButton.style";

export const ButtonGroupWrapper = styled.div`
  display: flex;
  gap: 9px;

  width: 100%;
  height: ${BUTTON_BOX.BUTTON_HEIGHT}px;
`;

export const ShareButtonBox = styled(motion.button)`
  padding: 12px;
  border-radius: 8px;

  svg {
    pointer-events: none;
  }
`;

const StyledButton = styled(motion.button)<{
  $bgColor?: string;
  $textColor?: string;
  $borderColor?: string;
}>`
  width: 100%;
  padding: 13px 16px;
  border: 1px solid ${({ $borderColor }) => $borderColor || "transparent"};
  border-radius: 8px;

  background-color: ${({ $bgColor }) => $bgColor || pink.main};

  color: ${({ $textColor }) => $textColor || grayScale.white};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
`;

export const FullButton = styled(StyledButton)`
  display: flex;
  justify-content: center;
  align-items: center;

  &:disabled {
    background-color: ${grayScale.main};

    color: ${grayScale[500]};

    cursor: not-allowed;
  }
`;
